/**
 * RouteGuard
 *
 * Capability-aware `<Route>`. It sits as a direct child of `<Switch>` and carries
 * `path`, so Switch matching is unchanged — every remaining route prop (including
 * the `computedMatch` Switch injects into the child it selects) is forwarded to a
 * real `<Route>` when the feature is visible.
 *
 * When the feature is hidden the route never mounts and the user is redirected to
 * the landing the current workflow allows, which blocks all entry points alike:
 * nav click, typed URL, back button and deep link.
 *
 * Gating lives here rather than inside each page because routes have mount-time
 * side effects — a page that checks its own visibility has already run them.
 */
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { isFeatureVisible } from '@makemydeal/dr-sales-checkin-store';

import type { RouteGuardProps } from '../../types';

const RouteGuard = ({ feature, ...routeProps }: RouteGuardProps) => {
    const isVisible = useSelector(isFeatureVisible(feature));

    if (isVisible) {
        return <Route {...routeProps} />;
    }

    return false;
};

export default RouteGuard;
